import { render } from "./CreateOrgJob.vue?vue&type=template&id=0af2cee8"
import script from "./CreateOrgJob.vue?vue&type=script&lang=js"
export * from "./CreateOrgJob.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__